import { ProductCards } from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useCustomerEndpoint, useWorkspace } from '@aibees/shared/workspace';

/**
 * Card view of the pricing catalog (`return=cards`): sections nested by
 * `sectionRank`, each with features pre-sorted by `cardOrder`. Distinct query
 * key from `useBrowseProductEntitlementApi` (the `return=features` compare
 * shape), so the two views are cached independently.
 */
export function useBrowseProductCardsApi() {
  const url = useCustomerEndpoint('entitlement');
  const wid = useWorkspace()?.id;

  // `url` embeds the workspace id, so it has to be part of the key — otherwise
  // a workspace switch without a full remount serves the previous customer's
  // catalog from cache.
  return useBaseQuery<never, ProductCards>(
    [useBrowseProductCardsApi.name, url],
    {
      url,
      params: {
        return: 'cards',
        groupByFamily: true,
      },
    },
    { enabled: !!wid }
  );
}
